// Generic dropdown primitive. Markup contract:
//
//   <div data-dropdown>
//     <button data-dropdown-trigger aria-haspopup="menu" aria-expanded="false">…</button>
//     <div data-dropdown-menu role="menu" class="hidden data-[open=true]:block">…</div>
//   </div>
//
// Click trigger toggles. Click outside or Escape closes. Event-delegated on
// document so it survives Turbo navigations without re-binding.

function closeAll(except = null) {
  document.querySelectorAll('[data-dropdown][data-open="true"]').forEach((d) => {
    if (d === except) return;
    d.dataset.open = "false";
    const t = d.querySelector("[data-dropdown-trigger]");
    if (t) t.setAttribute("aria-expanded", "false");
  });
}

document.addEventListener("click", (e) => {
  const trigger = e.target.closest("[data-dropdown-trigger]");
  if (trigger) {
    e.preventDefault();
    const dropdown = trigger.closest("[data-dropdown]");
    if (!dropdown) return;
    const willOpen = dropdown.dataset.open !== "true";
    closeAll(dropdown);
    dropdown.dataset.open = willOpen ? "true" : "false";
    trigger.setAttribute("aria-expanded", String(willOpen));
    return;
  }
  // Click outside any open dropdown closes it.
  document.querySelectorAll('[data-dropdown][data-open="true"]').forEach((d) => {
    if (!d.contains(e.target)) {
      d.dataset.open = "false";
      const t = d.querySelector("[data-dropdown-trigger]");
      if (t) t.setAttribute("aria-expanded", "false");
    }
  });
});

document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
  const open = document.querySelector('[data-dropdown][data-open="true"]');
  if (!open) return;
  open.dataset.open = "false";
  const t = open.querySelector("[data-dropdown-trigger]");
  if (t) {
    t.setAttribute("aria-expanded", "false");
    t.focus();
  }
});
